/**
 * El nombre de una plataforma, igual en todas las pantallas: el pedido manual, la Ayuda y los avisos
 * de riders. Antes había tres copias y cada una trataba de otra forma los ids que no conocía: el
 * pedido manual ponía en mayúscula la primera letra de cada palabra de un id que ya viene en
 * mayúsculas (`CHEERFY` se quedaba `CHEERFY`), y las otras dos dejaban el guion bajo (`Drive_thru`).
 *
 * - Las marcas, como las escribe cada una.
 * - Los canales propios del restaurante (reparto propio, recogida), traducidos.
 * - Cualquier otro id, legible a partir de sí mismo: `DRIVE_THRU` → «Drive Thru», `LOCAL` → «Local».
 */

const BRAND_NAMES = {
  GLOVO: 'Glovo',
  JUSTEAT: 'Just Eat',
  UBER: 'Uber Eats',
  DELIVEROO: 'Deliveroo',
  PEDIDOSYA: 'PedidosYa',
};

const CHANNEL_KEYS = {
  OWN_DELIVERY: 'message.manualOrderOwnDelivery',
  TAKE_AWAY: 'message.manualOrderTakeAway',
};

/**
 * `DRIVE_THRU` → «Drive Thru»: minúsculas, espacios por guiones bajos y mayúscula al empezar cada
 * palabra (también detrás de un guion: `UBER-DIRECT` → «Uber-Direct»). Las siglas no se adivinan
 * (`KFC_APP` sería «Kfc App»): una marca que se escriba de otra forma va en BRAND_NAMES.
 */
export function humanizePlatformId(id) {
  return String(id || '')
    .toLowerCase()
    .replace(/_+/g, ' ')
    .trim()
    .replace(/(^|[\s-])(\p{L})/gu, (_, before, letter) => before + letter.toUpperCase());
}

/**
 * @param {string} id  el id de la plataforma del backend (`GLOVO`, `OWN_DELIVERY`, `DRIVE_THRU`…)
 * @param {(key: string) => string} [t]  vue-i18n, para los canales propios
 */
export function platformName(id, t = null) {
  if (!id) return '';
  if (BRAND_NAMES[id]) return BRAND_NAMES[id];
  if (CHANNEL_KEYS[id] && typeof t === 'function') return t(CHANNEL_KEYS[id]);
  return humanizePlatformId(id);
}
